import { render } from "./ContainersGroupView.vue?vue&type=template&id=7f048dc0"
import script from "./ContainersGroupView.vue?vue&type=script&lang=js"
export * from "./ContainersGroupView.vue?vue&type=script&lang=js"

import "./ContainersGroupView.vue?vue&type=style&index=0&id=7f048dc0&lang=css"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__